import http from '../http-common'
import TokenService from "./token.service";
import AuthService from "@/services/auth.service";

const setup = (store) => {
  http.interceptors.request.use(
      (config) => {
        const token = TokenService.getLocalAccessToken();
        if (token && config.url !== "/auth/refreshtoken") {
          config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
  );

  http.interceptors.response.use(
      (res) => {
        return res;
      },
      async (err) => {
        const originalConfig = err.config;

        if (originalConfig.url !== "/auth/login" && err.response) {
          // Access Token was expired
          if (err.response.status === 401 && !originalConfig._retry) {
            // originalConfig._retry = true;
          //
          //   try {
          //     const rs = await http.post("/auth/refreshtoken", {
          //       refreshToken: TokenService.getLocalRefreshToken(),
          //     });
          //
          //     const { accessToken } = rs.data;
          //
          //     store.dispatch('auth/refreshToken', accessToken);
          //     TokenService.updateLocalAccessToken(accessToken);
          //
          //     return http(originalConfig);
          //   } catch (_error) {
              AuthService.logout();
              return Promise.reject(err);
            // }
          }
        }

        return Promise.reject(err);
      }
  );
};

export default setup;
